export const FETCH_AGGREGATE_PREDEIFENED_FIELD = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Aggregate_Predefined_Field'
export const FETCH_AGGREGATE_PREDEIFENED_FIELD_SUCCESS = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Aggregate_Predefined_Field_Success'
export const FETCH_AGGREGATE_PREDEIFENED_FIELD_FAILURE = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Aggregate_Predefined_Field_Failure'
export const fetchAggregatePredefined = () => {
    return {
        type: FETCH_AGGREGATE_PREDEIFENED_FIELD
    }
}
export const fetchAggregatePredefinedSuccess = (data) => {
    return {
        type: FETCH_AGGREGATE_PREDEIFENED_FIELD_SUCCESS,
        data
    }
}
export const fetchAggregatePredefinedFailure = (data) => {
    return {
        type: FETCH_AGGREGATE_PREDEIFENED_FIELD_FAILURE,
        data
    }
}

export const FETCH_VARIABLE_PREDEIFENED_FIELD = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Variable_Predefined_Field'
export const FETCH_VARIABLE_PREDEIFENED_FIELD_SUCCESS = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Variable_Predefined_Field_Success'
export const FETCH_VARIABLE_PREDEIFENED_FIELD_FAILURE = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Varibale_Predefined_Field_Failure'
export const fetchVariablePredefined = () => {
    return {
        type: FETCH_VARIABLE_PREDEIFENED_FIELD
    }
}
export const fetchVariablePredefinedSuccess = (data) => {
    return {
        type: FETCH_VARIABLE_PREDEIFENED_FIELD_SUCCESS,
        data
    }
}
export const fetchVariablePredefinedFailure = (data) => {
    return {
        type: FETCH_VARIABLE_PREDEIFENED_FIELD_FAILURE,
        data
    }
}


export const SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Save_Credit_Worthiness_Global_Config';
export const SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG_SUCCESS = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Save_Credit_Worthiness_Global_Config_Success';
export const SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG_FAILURE = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Save_Credit_Worthiness_Global_Config_Failure';

export const saveCreditWorthiness = (data) => {
    return {
        type: SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG,
        data
    }
}
export const saveCreditWorthinessSuccess = (data) => {
    return {
        type: SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG_SUCCESS,
        data
    }
}
export const saveCreditWorthinessFailure = (data) => {
    return {
        type: SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG_FAILURE,
        data
    }
}
export const FETCH_GLOBAL_CONFIGURATION = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Global_Configuration';
export const FETCH_GLOBAL_CONFIGURATION_SUCCESS = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Global_Configuration_Success';
export const FETCH_GLOBAL_CONFIGURATION_FAILURE = 'src/Admin/CreditWorthiness/GlobalConfiguration/action/Fetch_Global_Configuration_Failure';
export const fetchGlobalConfiguration = () => {
    return {
        type: FETCH_GLOBAL_CONFIGURATION
    }
}
export const fetchGlobalConfigurationSuccess = (data) => {
    return {
        type: FETCH_GLOBAL_CONFIGURATION_SUCCESS,
        data
    }
}
export const fetchGlobalConfigurationFailure = (data) => {
    return {
        type: FETCH_GLOBAL_CONFIGURATION_FAILURE,
        data
    }
}

export const GET_MASTER_DATA_KEY_LIST = 'src/Admin/SectionTemplate/ViewMasterData/action/Get_Master_Data_Key_List';
export const GET_MASTER_DATA_KEY_LIST_SUCCESS = 'src/Admin/SectionTemplate/ViewMasterData/action/Get_Master_Data_Key_List_Success';
export const GET_MASTER_DATA_KEY_LIST_FAILURE = 'src/Admin/SectionTemplate/ViewMasterData/action/Get_Master_Data_Key_List_Failure';
export const getMasterDataKeyList = (data) => {
    return {
        type: GET_MASTER_DATA_KEY_LIST,
        data
    }
}
export const getMasterDataKeySuccess = (data) => {
    return {
        type: GET_MASTER_DATA_KEY_LIST_SUCCESS,
        data
    }
}
export const getMasterDataKeyFailure = (data) => {
    return {
        type: GET_MASTER_DATA_KEY_LIST_FAILURE,
        data
    }
}

export const CREATE_MASTER_DATA_KEY = 'src/Admin/SectionTemplate/ViewMasterData/action/Create_Master_Data_Key';
export const CREATE_MASTER_DATA_KEY_SUCCESS = 'src/Admin/SectionTemplate/ViewMasterData/action/Create_Master_Data_Key_Success';
export const CREATE_MASTER_DATA_KEY_FAILURE = 'src/Admin/SectionTemplate/ViewMasterData/action/Create_Master_Data_Key_Failure';
export const createMasterDataKey = (data) => {
    return {
        type: CREATE_MASTER_DATA_KEY,
        data
    }
}
export const createMasterDataKeySuccess = (data) => {
    return {
        type: CREATE_MASTER_DATA_KEY_SUCCESS,
        data
    }
}
export const createMasterDataKeyFailure = (data) => {
    return {
        type: CREATE_MASTER_DATA_KEY_FAILURE,
        data
    }
}

export const DOWNLOAD_XBRL_MASTER_TEMPLATE = 'src/Admin/GlobalConfigurations/action/Download_Xbrl_Master_Template'
export const DOWNLOAD_XBRL_MASTER_TEMPLATE_SUCCESS = 'src/Admin/GlobalConfigurations/action/Download_Xbrl_Master_Template_Success'
export const DOWNLOAD_XBRL_MASTER_TEMPLATE_FAILURE = 'src/Admin/GlobalConfigurations/action/Download_Xbrl_Master_Template_Failure'

export const downloadXbrlMasterTemplate = (data) => {
    return {
        type: DOWNLOAD_XBRL_MASTER_TEMPLATE,
        data
    }
}
export const downloadXbrlMasterTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_XBRL_MASTER_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadXbrlMasterTemplateFailure = (data) => {
    return {
        type: DOWNLOAD_XBRL_MASTER_TEMPLATE_FAILURE,
        data
    }
}

export const UPLOAD_XBRL_MASTER_TEMPLATE = 'src/Admin/GlobalConfigurations/action/Upload_Xbrl_Master_Template'
export const UPLOAD_XBRL_MASTER_TEMPLATE_SUCCESS = 'src/Admin/GlobalConfigurations/action/Upload_Xbrl_Master_Template_Success'
export const UPLOAD_XBRL_MASTER_TEMPLATE_FAILURE = 'src/Admin/GlobalConfigurations/action/Upload_Xbrl_Master_Template_Failure'

export const uploadXbrlMasterTemplate = (data) => {
    return {
        type: UPLOAD_XBRL_MASTER_TEMPLATE,
        data
    }
}
export const uploadXbrlMasterTemplateSuccess = (data) => {
    return {
        type: UPLOAD_XBRL_MASTER_TEMPLATE_SUCCESS,
        data
    }
}
export const uploadXbrlMasterTemplateFailure = (data) => {
    return {
        type: UPLOAD_XBRL_MASTER_TEMPLATE_FAILURE,
        data
    }
}

export const XBRL_MAPPING_STATISTICS = 'src/Admin/GlobalConfigurations/action/Xbrl_Mapping_Statistics'
export const XBRL_MAPPING_STATISTICS_SUCCESS = 'src/Admin/GlobalConfigurations/action/Xbrl_Mapping_Statistics_Success'
export const XBRL_MAPPING_STATISTICS_FAILURE = 'src/Admin/GlobalConfigurations/action/Xbrl_Mapping_Statistics_Failure'

export const fetchXbrlMappingStatistics = (data) => {
    return {
        type: XBRL_MAPPING_STATISTICS,
        data
    }
}
export const fetchXbrlMappingStatisticsSuccess = (data) => {
    return {
        type: XBRL_MAPPING_STATISTICS_SUCCESS,
        data
    }
}
export const fetchXbrlMappingStatisticsFailure = (data) => {
    return {
        type: XBRL_MAPPING_STATISTICS_FAILURE,
        data
    }
}

export const FETCH_MASTERKEY_BY_APIKEY = 'src/Admin/GlobalConfigurations/action/Fetch_MasterKey_By_ApiKey'
export const FETCH_MASTERKEY_BY_APIKEY_SUCCESS = 'src/Admin/GlobalConfigurations/action/Fetch_MasterKey_By_ApiKey_Success'
export const FETCH_MASTERKEY_BY_APIKEY_FAILURE = 'src/Admin/GlobalConfigurations/action/Fetch_MasterKey_By_ApiKey_Failure'

export const fetchMasterKeyByApiKey = (data) => {
    return {
        type: FETCH_MASTERKEY_BY_APIKEY,
        data
    }
}
export const fetchMasterKeyByApiKeySuccess = (data) => {
    return {
        type: FETCH_MASTERKEY_BY_APIKEY_SUCCESS,
        data
    }
}
export const fetchMasterKeyByApiKeyFailure = (data) => {
    return {
        type: FETCH_MASTERKEY_BY_APIKEY_FAILURE,
        data
    }
}

export const DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE = 'src/Admin/GlobalConfigurations/action/Download_Bulk_Master_Key_Request_Template';
export const DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE_SUCCESS = 'src/Admin/GlobalConfigurations/action/Download_Bulk_Master_Key_Request_Template_Success';
export const DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE_FAILURE = 'src/Admin/GlobalConfigurations/action/Download_Bulk_Master_Key_Request_Template_Failure';
export const downloadBulkMasterKeyRequestTemplate = (data) => {
    return {
        type: DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE,
        data
    }
}
export const downloadBulkMasterKeyRequestTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadBulkMasterKeyRequestTemplateFailure = (error) => {
    return {
        type: DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE_FAILURE,
        error
    }
}

export const SUBMIT_BULK_MASTER_KEY_REQUEST = 'src/Admin/GlobalConfigurations/action/Submit_Bulk_Master_Key_Request';
export const SUBMIT_BULK_MASTER_KEY_REQUEST_SUCCESS = 'src/Admin/GlobalConfigurations/action/Submit_Bulk_Master_Key_Request_Success';
export const SUBMIT_BULK_MASTER_KEY_REQUEST_FAILURE = 'src/Admin/GlobalConfigurations/action/Submit_Bulk_Master_Key_Request_Failure';
export const submitBulkMasterKeyRequest = (data) => {
    return {
        type: SUBMIT_BULK_MASTER_KEY_REQUEST,
        data
    }
}
export const submitBulkMasterKeyRequestSuccess = (data) => {
    return {
        type: SUBMIT_BULK_MASTER_KEY_REQUEST_SUCCESS,
        data
    }
}
export const submitBulkMasterKeyRequestFailure = (error) => {
    return {
        type: SUBMIT_BULK_MASTER_KEY_REQUEST_FAILURE,
        error
    }
}

export const API_ACCESSES_INFO = 'src/Admin/GlobalConfigurations/action/Api_Accesses_Info'
export const API_ACCESSES_INFO_SUCCESS = 'src/Admin/GlobalConfigurations/action/Api_Accesses_Info_Success'
export const API_ACCESSES_INFO_FAILURE = 'src/Admin/GlobalConfigurations/action/Api_Accesses_Info_Failure'

export const fetchApiAccessesInfo = (data) => {
    return {
        type: API_ACCESSES_INFO,
        data
    }
}
export const fetchApiAccessesInfoSuccess = (data) => {
    return {
        type: API_ACCESSES_INFO_SUCCESS,
        data
    }
}
export const fetchApiAccessesInfoFailure = (error) => {
    return {
        type: API_ACCESSES_INFO_FAILURE,
        error
    }
}

export const API_ACCESS_TYPES = 'src/Admin/GlobalConfigurations/action/Api_Access_Types'
export const API_ACCESS_TYPES_SUCCESS = 'src/Admin/GlobalConfigurations/action/Api_Access_Types_Success'
export const API_ACCESS_TYPES_FAILURE = 'src/Admin/GlobalConfigurations/action/Api_Access_Types_Failure'

export const fetchApiAccessTypes = (data) => {
    return {
        type: API_ACCESS_TYPES,
        data
    }
}
export const fetchApiAccessTypesSuccess = (data) => {
    return {
        type: API_ACCESS_TYPES_SUCCESS,
        data
    }
}
export const fetchApiAccessTypesFailure = (error) => {
    return {
        type: API_ACCESS_TYPES_FAILURE,
        error
    }
}

export const API_ACCESSES_SUBMIT = 'src/Admin/GlobalConfigurations/action/Api_Accesses_Submit'
export const API_ACCESSES_SUBMIT_SUCCESS = 'src/Admin/GlobalConfigurations/action/Api_Accesses_Submit_Success'
export const API_ACCESSES_SUBMIT_FAILURE = 'src/Admin/GlobalConfigurations/action/Api_Accesses_Submit_Failure'

export const submitApiAccesses = (data) => {
    return {
        type: API_ACCESSES_SUBMIT,
        data
    }
}
export const submitApiAccessesSuccess = (data) => {
    return {
        type: API_ACCESSES_SUBMIT_SUCCESS,
        data
    }
}
export const submitApiAccessesInfoFailure = (error) => {
    return {
        type: API_ACCESSES_SUBMIT_FAILURE,
        error
    }
}